import React from 'react';

const Loader = ({ isLoading = false, fullScreen = true }) => {
  if (!isLoading) return null;

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20">
        <img src="/flight_logo.gif" alt="Loading..." className="w-50 h-50" />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-6">
      <img src="/flight_logo.gif" alt="Loading..." className="w-50 h-50" />
    </div>
  );
};

export default Loader;
